import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search, Filter, MoreHorizontal, FileText, CheckCircle2, Clock } from 'lucide-react';
export function Assessments() {
  const [activeTab, setActiveTab] = useState('active');
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-565" data-mp="jkum8bo4yb5l">
      <div className="flex justify-between items-center" data-id="element-566" data-mp="oeyvx2oscxad">
        <div data-id="element-567" data-mp="td0cngyqokio">
          <h1 className="text-2xl font-semibold text-slate-900" data-id="element-568" data-mp="tda83k2jzjvr">Assessments</h1>
          <p className="text-slate-500 mt-1" data-id="element-569" data-mp="ybbqs3w2hh6p">
            Manage assessment cycles and templates.
          </p>
        </div>
        <Link to="/app/assessments/new" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors flex items-center" data-id="element-570" data-mp="12e8da5oq9xfx">
          <Plus className="h-4 w-4 mr-2" data-id="element-571" data-mp="345lbyd03r93j" />
          New Cycle
        </Link>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200 pb-4" data-id="element-572" data-mp="392tpu1e7wqyz">
        <div className="flex space-x-6" data-id="element-573" data-mp="z00vudhesfjj">
          <button onClick={() => setActiveTab('active')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'active' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-574" data-mp="u7r9t8jezzmj">
            Active Cycles
          </button>
          <button onClick={() => setActiveTab('drafts')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'drafts' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-575" data-mp="1hxln1r7nbq7b">
            Drafts
          </button>
          <button onClick={() => setActiveTab('completed')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'completed' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-576" data-mp="13x10ql2ivc92">
            Completed
          </button>
          <button onClick={() => setActiveTab('templates')} className={`text-sm font-medium pb-4 -mb-4 border-b-2 transition-colors ${activeTab === 'templates' ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-577" data-mp="3v41ps38gkz79">
            Templates
          </button>
        </div>

        <div className="flex items-center space-x-3" data-id="element-578" data-mp="37dnv04yhom8z">
          <div className="relative" data-id="element-579" data-mp="3c55x4wc90svj">
            <Search className="absolute left-3 top-2 h-4 w-4 text-slate-400" data-id="element-580" data-mp="3c67ipuqw4xri" />
            <input type="text" placeholder="Search..." className="pl-9 pr-3 py-1.5 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-slate-200 w-48" data-id="element-581" data-mp="2yeauw2w99a0x" />
          </div>
          <button className="p-1.5 border border-slate-200 rounded-md text-slate-500 hover:bg-slate-50" data-id="element-582" data-mp="2ohoblijkur10">
            <Filter className="h-4 w-4" data-id="element-583" data-mp="2tgr98hx89uyy" />
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-584" data-mp="29upm3t4a66ox">
        <table className="w-full text-left border-collapse" data-id="element-585" data-mp="24w5zdqhv4qvi">
          <thead data-id="element-586" data-mp="2jrty504ewls0">
            <tr className="bg-slate-50 border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500 font-medium" data-id="element-587" data-mp="2jsdkct13hwbu">
              <th className="p-4" data-id="element-588" data-mp="2srqulnx1moxm">Name</th>
              <th className="p-4" data-id="element-589" data-mp="2sqp7um6o0e02">Status</th>
              <th className="p-4" data-id="element-590" data-mp="2spe24gtnsw6b">Progress</th>
              <th className="p-4" data-id="element-591" data-mp="2nrmc5sckrk4r">Due Date</th>
              <th className="p-4 text-right" data-id="element-592" data-mp="2nqkx7csfudhr">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 text-sm" data-id="element-593" data-mp="32jmt3031kh2d">
            <tr className="hover:bg-slate-50 transition-colors" data-id="element-594" data-mp="2xjibf6qedgak">
              <td className="p-4" data-id="element-595" data-mp="3bhys9qhz4n6f">
                <div className="flex items-center" data-id="element-596" data-mp="3bj1idw7h2lla">
                  <FileText className="h-5 w-5 text-slate-400 mr-3" data-id="element-597" data-mp="37gn13gjgbtw4" />
                  <div data-id="element-598" data-mp="37ihk2pb5xbxk">
                    <div className="font-medium text-slate-900" data-id="element-599" data-mp="14tzif48ixo4f">
                      Q3 Leadership Review
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-600" data-mp="19sar3bn31sl2">
                      12 Subjects • 48 Evaluators
                    </div>
                  </div>
                </div>
              </td>
              <td className="p-4" data-id="element-601" data-mp="1jj5fomnsx49o">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800" data-id="element-602" data-mp="1ji2oseqhb1tr">
                  <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-1.5" data-id="element-603" data-mp="qtyfzkcm28mu"></span>
                  Active
                </span>
              </td>
              <td className="p-4" data-id="element-604" data-mp="vrzzu7hv2bzd">
                <div className="flex items-center space-x-2" data-id="element-605" data-mp="zuwoaeu312b8">
                  <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-606" data-mp="zw7rodjm881t">
                    <div className="bg-slate-900 h-full w-[65%]" data-id="element-607" data-mp="277x0uu2z4mcy"></div>
                  </div>
                  <span className="text-xs text-slate-500" data-id="element-608" data-mp="2b8qnlk4ojv49">65%</span>
                </div>
              </td>
              <td className="p-4 text-slate-600" data-id="element-609" data-mp="3vrkrt2b4gpo7">Oct 15, 2023</td>
              <td className="p-4 text-right" data-id="element-610" data-mp="3rq8wqh9hbc8m">
                <button className="text-slate-400 hover:text-slate-600" data-id="element-611" data-mp="3rrahxek7lf42">
                  <MoreHorizontal className="h-5 w-5" data-id="element-612" data-mp="3myhf4w8awgum" />
                </button>
              </td>
            </tr>

            <tr className="hover:bg-slate-50 transition-colors" data-id="element-613" data-mp="3i0flxih5v15f">
              <td className="p-4" data-id="element-614" data-mp="3d1uv29nstttn">
                <div className="flex items-center" data-id="element-615" data-mp="3d2waeqbul2h6">
                  <FileText className="h-5 w-5 text-slate-400 mr-3" data-id="element-616" data-mp="3820302saey70" />
                  <div data-id="element-617" data-mp="384un1t7e2gzw">
                    <div className="font-medium text-slate-900" data-id="element-618" data-mp="340emm7gjo1s2">
                      Engineering Team 360
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-619" data-mp="2z3eezs41qqyu">
                      24 Subjects • 96 Evaluators
                    </div>
                  </div>
                </div>
              </td>
              <td className="p-4" data-id="element-620" data-mp="xazzt0sw00m4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800" data-id="element-621" data-mp="x8m8n31bv8ju">
                  <span className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-1.5" data-id="element-622" data-mp="1l61y5hrwrpna"></span>
                  Nominations
                </span>
              </td>
              <td className="p-4" data-id="element-623" data-mp="17ckezy34wexs">
                <div className="flex items-center space-x-2" data-id="element-624" data-mp="1ccoylwzc9ps8">
                  <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-625" data-mp="1cb4241tgrwrq">
                    <div className="bg-slate-900 h-full w-[15%]" data-id="element-626" data-mp="200yeyjds9lbz"></div>
                  </div>
                  <span className="text-xs text-slate-500" data-id="element-627" data-mp="243v0ahupjvjm">15%</span>
                </div>
              </td>
              <td className="p-4 text-slate-600" data-id="element-628" data-mp="1q6zfxt90aho9">Oct 30, 2023</td>
              <td className="p-4 text-right" data-id="element-629" data-mp="1v2ohu38i0anq">
                <button className="text-slate-400 hover:text-slate-600" data-id="element-630" data-mp="eppx98xpbto0">
                  <MoreHorizontal className="h-5 w-5" data-id="element-631" data-mp="eoev1djwmtz0" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}